<template>
  <div id="ledResolutionMenu">
    <div class="menu">
      <el-form class="section-wrapper" :model="menuItemData" ref="ledConfigurationMenuForm" id="ledConfigurationMenuForm" @submit.prevent>
        <template v-for="(menuItem, menuItemKey) in menuItems">
          <el-form-item v-if="!menuItem.disabled" :id="menuItem.id" :key="menuItemKey" class="property">
            <div class="title title-cstm-sm m-0!">{{menuItem.name}}</div>

            <el-col :class="['content common', menuItem.id]">
              <el-form-item v-if="!menuItem.hasOwnProperty('array')" prop="media" :class="['form-item single-type', menuItem.id]">
                <div class="editable">
                  <div v-if="menuItem.id === 'resolution'" class="no-property resolution-wrapper" :id="menuItem.id">
                    <el-input v-model="menuItemData[menuItem.id].width" type="number" @input="handleMenuItemChange(menuItem)" :class="['el-input-cstm-sm', { 'has-error': formErrors[menuItem.id] }]"></el-input>
                    <span>{{'X'}}</span>
                    <el-input v-model="menuItemData[menuItem.id].height" type="number" @input="handleMenuItemChange(menuItem)" :class="['el-input-cstm-sm', { 'has-error': formErrors[menuItem.id] }]"></el-input>
                  </div>
                </div>
              </el-form-item>
              <p v-if="formErrors[menuItem.id]" class="pt-1 leading-none text-[#F46D6D] text-left">{{ formErrors[menuItem.id] }}</p>
            </el-col>
          </el-form-item>
        </template>

        <div @click.capture="showResolutionCalc" :class="['icon calc', {'selected': showCalculator}]"></div>
        <div v-if="showCalculator" class="calculator-wrapper">
          <resolution-calculator :resolutionProp="updateCalcResolution" @resolution-calcultor-change="handleResolutionCalChange($event)"></resolution-calculator>
        </div>

        <!-- Canvas Name -->
        <div v-if="isVideoWall" class="canvas-name">
          <hr>
          <div class="text-xs text-left text-[#9FA0AD] uppercase font-semibold mt-[6px]">{{$t('playerSetup.canvasName')}}</div>
          <el-input class="el-input-cstm-sm my-[6px]" v-model="canvasName" @input="onInputCanvasName"></el-input>
        </div>

        <div ref="submitButtonWrapper" :class="['submit-btn-wrapper', { 'show-calc': showCalculator }]">
          <el-button
            v-if="showCancelBtn"
            class="cstm-btn-grey cancel-btn width-125"
            @click="handleCloseForm">
            {{$t('label.cancel')}}
          </el-button>

          <el-button @click="handleNewSetting" class="cstm-btn-gradient width-125">
            <template v-if="isVideoWall">{{$t('label.create')}}</template>
            <template v-else>{{$t('label.ok')}}</template>
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script src="./led-resolution-menu.js"></script>
<style lang="scss" src="./led-resolution-menu.scss"></style>
